
export const SAVE_SCHOOL_PSYCHOLOGY_REQUEST = 'SAVE_SCHOOL_PSYCHOLOGY_REQUEST';
export const SAVE_SCHOOL_PSYCHOLOGY_REQUEST_SUCCESS = 'SAVE_SCHOOL_PSYCHOLOGY_REQUEST_SUCCESS';
export const SAVE_SCHOOL_PSYCHOLOGY_REQUEST_FAIL = 'SAVE_SCHOOL_PSYCHOLOGY_REQUEST_FAIL'

export const GET_SCHOOL_PSYCHOLOGY_REQUEST = 'GET_SCHOOL_PSYCHOLOGY_REQUEST';
export const GET_SCHOOL_PSYCHOLOGY_REQUEST_SUCCESS = 'GET_SCHOOL_PSYCHOLOGY_REQUEST_SUCCESS';
export const GET_SCHOOL_PSYCHOLOGY_REQUEST_FAIL = 'GET_SCHOOL_PSYCHOLOGY_REQUEST_FAIL'
